import {makeTrackEvent} from '../../services/analytics/makeTrackEvent';

type SearchHistoryAction =
  | 'Item added'
  | 'Item selected'
  | 'Regex toggled'
  | 'Collapsed input';

type SearchHistoryLocation =
  | 'panel bank search'
  | 'workspace run selector'
  | 'report run selector';

export const trackSearchHistory = makeTrackEvent<
  {
    action: SearchHistoryAction;
    location: SearchHistoryLocation;
    regex?: 'on' | 'off';
    inputLength?: number;
    inputHeight?: number;
  },
  {
    action: {
      description: 'what action took place';
    };
    location: {
      description: 'where the action took place';
    };
    regex: {
      description: 'whether regex is on/ off';
    };
    inputLength: {
      description: 'input length on collapsing';
    };
    inputHeight: {
      description: 'input height on collapsing';
    };
    _description: 'Tracks panel bank search history actions';
    _location: 'Panel bank search input in a workspace; run selector search in both a workspace and reports';
    _motivation: 'track search history usage';
  }
>('Search history');
